module.exports = __webpack_public_path__ + "static/media/videolovers.2fce2fbd.svg";